/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Typography, styled } from "@mui/material";

export const GuestActivityLogCard = styled(Box)({
  border: '1px solid #d7dde8',
  borderRadius: '14px',
  backgroundColor: '#ffffff',
  padding: '20px 22px',
  minHeight: '240px',
  maxHeight: '740px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const GuestActivityLogTimeline = styled(Box)({
  display: 'grid',
  gap: '24px',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
});

export const GuestActivityLogGroup = styled(Box)({
  display: 'grid',
  gap: '14px',
});

export const GuestActivityLogDate = styled(Typography)({
  color: '#62748a',
  fontSize: '12px',
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
});

export const GuestActivityLogList = styled(Box)({
  display: 'grid',
  gap: '14px',
});

export const GuestActivityLogEvent = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '30px minmax(0, 1fr)',
  gap: '12px',
  alignItems: 'start',
});

export const GuestActivityLogEventIcon = styled(Box)({
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  border: '1px solid #d7dde8',
  color: '#6a7d93',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f8fbff',
  marginTop: '2px',
});

export const GuestActivityLogEventContent = styled(Box)({
  minWidth: 0,
  display: 'grid',
  gap: '2px',
});

export const GuestActivityLogEventHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
});

export const GuestActivityLogEventTitle = styled(Typography)({
  color: '#233044',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 1.35,
});

export const GuestActivityLogEventSubtitle = styled(Typography)({
  color: '#59708a',
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: 1.4,
  wordBreak: 'break-word',
});

export const GuestActivityLogEventTimestamp = styled(Typography)({
  color: '#7a8ea5',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 1.35,
});

export const GuestActivityLogEmptyState = styled(Box)({
  minHeight: '200px',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#62748a',
  fontSize: '14px',
  fontWeight: 500,
});

export const GuestActivityLogLoadingWrap = styled(Box)({
  display: 'grid',
  gap: '14px',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});
